/**
 * Runtime config — reads from Vite env vars at build time. Mirrors the
 * iOS Config.swift, but web has both dev (localhost via proxy) and prod
 * (deployed backend) variants.
 *
 * Set VITE_BACKEND_URL in `.env.local` (or via deploy env) to override.
 * In dev: prefer leaving unset; vite.config.ts proxies /api → :8000 so
 * relative fetches work without CORS friction.
 */

const RAW = import.meta.env.VITE_BACKEND_URL?.trim();

export const config = {
  /** Where backend lives. In dev, "" means "use the vite proxy at /api". */
  backendBaseUrl: RAW || "",

  /** Google OAuth Web Client ID for Google Identity Services.
   *  Each platform gets its own OAuth client in Google Cloud Console —
   *  the iOS Client ID is NOT reusable here. Backend accepts both
   *  audiences on `/auth/sign-in`. */
  googleClientIdWeb: import.meta.env.VITE_GOOGLE_CLIENT_ID_WEB?.trim() || "",
} as const;

/**
 * Build a URL for the backend. In dev with no VITE_BACKEND_URL, returns
 * "/api/<path>" so vite's dev proxy can forward it. In prod (or when
 * VITE_BACKEND_URL is set), returns the absolute URL.
 */
export function backendUrl(path: string): string {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  if (config.backendBaseUrl) {
    return `${config.backendBaseUrl}${cleanPath}`;
  }
  return `/api${cleanPath}`;
}
